// Libs
import type { FC } from "react";

// Components
import {
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    type RadioGroupProps,
} from "@mui/material";
import { useField } from "formik";
import { Trans } from "react-i18next";
import { TooltipIcon } from "src/components/generics/icons/tooltipIcon/TooltipIcon";

import "./RadioGroup.css";
export interface OptionType {
    name?: string;
    id?: string | number;
    disabled?: boolean;
    disabledReason?: string;
    endAdornment?: JSX.Element;
}

export interface RadioGroupComponentProps extends Omit<RadioGroupProps, "onChange" | "value"> {
    name: string;
    options: OptionType[];
    bottomAdornments?: JSX.Element[];
    topAdornments?: JSX.Element[];
    handleChange?: (value: any) => void;
}

export const RadioGroupComponent: FC<RadioGroupComponentProps> = ({
    name,
    children,
    options,
    bottomAdornments,
    topAdornments,
    handleChange,
}) => {
    const [field, , helpers] = useField(name);
    return (
        <FormControl component="fieldset">
            <RadioGroup
                aria-label={name}
                name={name}
                value={field.value}
                onChange={(_event, v) => {
                    if (handleChange) {
                        handleChange(v);
                    }
                    helpers.setValue(`${v}`);
                }}
            >
                {options &&
                    options.map((elm, index) => {
                        return (
                            <TooltipIcon
                                key={elm.id}
                                tooltipText={elm.disabled === true ? elm.disabledReason : ""}
                            >
                                <div>
                                    {topAdornments && topAdornments[index]}
                                    <FormControlLabel
                                        value={`${elm.id}`}
                                        control={<Radio />}
                                        label={
                                            <div className="fl-c-radio-group-label-container">
                                                <Trans i18nKey={elm.name}></Trans>
                                                {elm.endAdornment && (
                                                    <div className="fl-c-radio-group-label-endAdornment">
                                                        {elm.endAdornment}
                                                    </div>
                                                )}
                                            </div>
                                        }
                                        disabled={elm.disabled ?? false}
                                    />
                                    {bottomAdornments && bottomAdornments[index]}
                                </div>
                            </TooltipIcon>
                        );
                    })}
                {children}
            </RadioGroup>
        </FormControl>
    );
};
